import React, { useState } from "react";
import { Modal, Spin, Button, Icon } from "antd";
import { ApiPort } from "$ACTIONS/TLCAPI";
import { advpost } from "$ACTIONS/TlcRequest";
import showMessage from "$ACTIONS/messageUtil";
import CustomCheckbox from "@/CustomCheckbox";
import { numberformatter } from "$ACTIONS/util";

const CancellationModal = ({ visible, type, data, onClose, onSuccess }) => {
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isChecked, setIsChecked] = useState(false);

    const handleConfirm = async () => {
        Pushgtagdata(
            "Bonus",
            "Confirm Cancel Bonus and Rebate Record",
            "Bonus_C_ConfirmCancelBonusAndRebateRecord"
        );

        setIsSubmitting(true);

        try {
            const res = await advpost(
                `${ApiPort.POSTCancelBonusPromotion}&playerBonusId=${data?.playerBonusId}`
            );

            if (res?.isSuccess && res?.result?.isSuccess) {
                showMessage("success", "ยกเลิก", 80);
                onSuccess(data?.playerBonusId); // 调用回调函数，移除成功取消的 item
            } else {
                showMessage("error", "การยกเลิกล้มเหลว", 80);
            }
        } catch (error) {
            console.error("Error during cancellation:", error);
            showMessage("info", "โปรดลองอีกครั้งในภายหลัง", 80);
        } finally {
            setIsSubmitting(false);
            onClose(); // 成功后关闭弹窗
        }
    };

    const renderContent = () => {
        if (type === "PRE") {
            if (!data?.isTurnoverProgress) {
                // 無流水進展
                return (
                    <>
                        <p className="main-message">
                            การยกเลิกการขอรับโบนัสจะดึง "โบนัสปรับก่อน" คืน
                            <br />
                            <strong>{numberformatter(data?.pullbackAmount, 2, "removeWhenDecimalAllZero")}</strong> บาท
                        </p>
                        <div className="additional-info">
                            <p>
                                ยอดหมุนเวียนสะสมในช่วงโปรโมชั่นจะถือว่าเป็นโมฆะ
                            </p>
                        </div>
                    </>
                );
            } else if (data?.isTurnoverProgress && data?.winningAmount > 0) {
                // 有流水進展，且有贏錢
                return (
                    <>
                        <p className="main-message">
                            กำลังยกเลิกโบนัสที่ปรับให้ล่วงหน้า{" "}
                            <strong>{numberformatter(data?.pullbackAmount, 2, "removeWhenDecimalAllZero")}</strong> บาท
                        </p>
                        <div className="additional-info">
                            <ol className="numbered-list">
                                <li>
                                    การยกเลิกโปรโมชั่นนี้จะส่งผลให้มีการดึงโบนัส
                                    <br />
                                    "โบนัสปรับก่อน" คืน{" "}
                                    <strong>
                                        {numberformatter(data?.bonusGivenAmount, 2, "removeWhenDecimalAllZero")}
                                    </strong>{" "}
                                    บาท
                                    <br />
                                    รวมถึงยอดเงินชนะที่ได้จากโปรโมชั่นนี้{" "}
                                    <strong>{numberformatter(data?.winningAmount, 2, "removeWhenDecimalAllZero")}</strong> บาท
                                </li>
                                <li>
                                    ยอดหมุนเวียนสะสมในช่วงโปรโมชั่นจะถือว่าเป็นโมฆะ
                                </li>
                            </ol>
                        </div>
                    </>
                );
            } else if (data?.isTurnoverProgress && data?.winningAmount === 0) {
                // 有流水進展，但無贏錢
                return (
                    <>
                        <p className="main-message">
                            กำลังยกเลิกโบนัสที่ปรับให้ล่วงหน้า{" "}
                            <strong>{numberformatter(data?.pullbackAmount, 2, "removeWhenDecimalAllZero")}</strong> บาท
                        </p>
                        <div className="additional-info">
                            <p>
                                ยอดหมุนเวียนสะสมในช่วงโปรโมชั่นจะถือว่าเป็นโมฆะ
                            </p>
                        </div>
                    </>
                );
            }
        } else if (type === "POST") {
            return (
                <p className="main-message">
                    ยอดหมุนเวียนสะสมในช่วงโปรโมชั่นจะถือว่าเป็นโมฆะ
                </p>
            );
        }
    };

    return (
        <Modal
            className="custom-modal-white-bg cancellation-modal"
            visible={visible}
            onCancel={onClose}
            footer={null}
            centered
            title="เคล็ดลับสำคัญ"
            width={426}
        >
            <Spin spinning={isSubmitting} tip="กำลังโหลด กรุณารอสักครู่...">
                <div className="cancellation-modal-content">
                    {/* Warning Icon */}
                    <div className="warning-icon">
                        <img src="/th/img/icon/warning.svg" alt="Warning" />
                    </div>

                    {/* content */}
                    {renderContent()}

                    {/* Checkbox */}
                    <div className="checkbox-container">
                        {/* 我已阅读上述说明，并同意取消进行中的优惠 */}
                        <CustomCheckbox
                            checked={isChecked}
                            onChange={(v) => setIsChecked(v)}
                            label={
                                <>
                                    ฉันได้อ่านเนื้อหาข้างต้นแล้ว
                                    <br />
                                    และ<strong>ยินยอมที่จะยกเลิกข้อเสนอ</strong>
                                    ที่กำลังดำเนินอยู่
                                </>
                            }
                        />
                    </div>

                    {/* Action Buttons */}
                    <div className="action-buttons">
                        <Button
                            type="primary"
                            size="large"
                            block
                            disabled={!isChecked}
                            onClick={handleConfirm}
                        >
                            ยืนยัน
                        </Button>
                        <Button
                            type="primary"
                            size="large"
                            block
                            ghost
                            onClick={onClose}
                        >
                            กลับ
                        </Button>
                    </div>
                </div>
            </Spin>
        </Modal>
    );
};

export default CancellationModal;
